import React, { useEffect, useState } from "react";

import { Spinner } from "react-bootstrap";

import { useTypedParams } from "react-router-typesafe-routes/dom";
import { ROUTES } from "src/routes";

import { ParentPercentages, useGetBeneficiaryViewLazyQuery, useSearchParticipantsQuery } from "@api/graphql";
import { ArtCentreArtists } from "@components/account_profile/account_relationships/ArtCentreArtists";
import { isAgent, isArtCentre, isArtist, isCMO } from "@util/index";

import AssociatedArtist from "./account_relationships/AssociatedArtist";
import { CurrentRecipients } from "./account_relationships/CurrentRecipients";

export const getBeneficiaryPercentage = (parentPercentages: ParentPercentages[], parent_artist_id: number) => {
  return parentPercentages.find((attribute) => attribute.parent === parent_artist_id)?.percentage;
};

const AccountRelationships = () => {
  const { participantId: participantIdFromUrl } = useTypedParams(ROUTES.Profile.AccountDetails);
  const [participantId, setParticipantId] = useState<number | undefined>(participantIdFromUrl);

  useEffect(() => {
    setParticipantId(participantIdFromUrl);
  }, [participantIdFromUrl]);

  const { data: participantData, loading: participantLoading } = useSearchParticipantsQuery({
    variables: {
      filter_by: [{ field: "participant_id", eq: participantId!.toString() }],
    },
    skip: !participantId,
  });

  const participant = participantData?.searchParticipants?.[0];

  const [getBeneficiaryView, { data: beneficiary, loading: beneficiaryLoading, refetch: refetchBeneficiary }] =
    useGetBeneficiaryViewLazyQuery();

  useEffect(() => {
    if (participant && !isArtCentre(participant?.participant_types)) {
      getBeneficiaryView({ variables: { recipientId: participantId ? participantId : 0 } });
    }
  }, [participant, participantId, getBeneficiaryView]);

  const relations = beneficiary?.getBeneficiaryView?.relations || [];

  return (
    <div>
      {(participantLoading || beneficiaryLoading) && (
        <div className="w-100 d-flex justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}

      {!participantLoading && participant && (
        <>
          {!isArtCentre(participant?.participant_types) &&
            !isCMO(participant?.participant_types) &&
            !isAgent(participant?.participant_types) && (
              <>
                <CurrentRecipients isArtist={isArtist(participant?.participant_types)} participantId={participantId} />
                <AssociatedArtist
                  participantId={participantId}
                  relations={relations}
                  participant={participant}
                  refetchBeneficiary={refetchBeneficiary}
                />
              </>
            )}

          {(isArtCentre(participant?.participant_types) ||
            isCMO(participant?.participant_types) ||
            isAgent(participant?.participant_types)) && (
            <ArtCentreArtists
              participantId={participantId}
              isArtCentre={isArtCentre(participant?.participant_types)}
              isCMO={isCMO(participant?.participant_types)}
              isAgent={isAgent(participant?.participant_types)}
              participantStatus={participant?.participant_status}
            />
          )}
        </>
      )}
    </div>
  );
};

export default AccountRelationships;
